import classNames from 'classnames';
import React, { forwardRef, useCallback, useEffect, useState } from 'react';

import { AccordionWrapper } from './components/accordion-wrapper';
import { AccordionProps } from './models';

const noJsCss = `
.cds-accordion__item-content-wrapper {
  height: auto !important;
}

.cds-accordion__item-content {
  opacity: 1 !important;
}

.cds-accordion__opener .icon__prefix {
  display: none !important;
}

.cds-accordion__opener .icon__suffix {
  display: none !important;
}
`;

export const Accordion = forwardRef<HTMLDivElement, AccordionProps>(
  (
    {
      className,
      semanticVariant,
      expandedIndex,
      items,
      expandVariant = 'multiple',
      headlineTag,
      openIcon,
      closeIcon,
      viewVariant = 'card',
      onChange,
    },
    ref
  ) => {
    const [selectedIndex, setSelectedIndex] = useState<number[]>([]);

    const onCloseAccordionItem = useCallback(
      (index: number) => {
        if (selectedIndex.some((i) => i === index)) {
          setSelectedIndex([...selectedIndex.filter((el) => el !== index)]);
        }
      },
      [selectedIndex]
    );

    const handleTogglerAccordionItem = useCallback(
      (index: number) => () => {
        if (onChange) onChange(index, !selectedIndex.some((i) => i === index));
        if (expandVariant === 'single') {
          return selectedIndex[0] === index
            ? onCloseAccordionItem(index)
            : setSelectedIndex([index]);
        }
        if (selectedIndex.some((i) => i === index)) {
          return onCloseAccordionItem(index);
        }

        return setSelectedIndex([...selectedIndex, index]);
      },
      [expandVariant, selectedIndex, onChange, onCloseAccordionItem]
    );

    useEffect(() => {
      if (expandedIndex) {
        const disabledItems = items
          .map((el, index) => el.disabled && index)
          .filter(Boolean);
        const filteredExpandedIndex = expandedIndex.filter(
          (el) => !disabledItems.includes(el)
        );

        if (expandVariant === 'single' && filteredExpandedIndex.length) {
          setSelectedIndex([filteredExpandedIndex[0]]);
        }
        if (expandVariant === 'multiple') {
          setSelectedIndex(filteredExpandedIndex);
        }
      }
    }, [expandVariant, expandedIndex, items]);

    return (
      <div
        ref={ref}
        className={classNames(
          'cds-accordion',
          `cds-accordion__${viewVariant}`,
          className
        )}
      >
        <AccordionWrapper
          items={items}
          semanticVariant={semanticVariant}
          selectedIndex={selectedIndex}
          headlineTag={headlineTag}
          openIcon={openIcon}
          closeIcon={closeIcon}
          handleTogglerAccordionItem={handleTogglerAccordionItem}
          viewVariant={viewVariant}
        />
        <noscript>
          <style>{noJsCss}</style>
        </noscript>
      </div>
    );
  }
);
